import Badge from "../../components/badge";
import { LoanStatusEnum } from "../../models";
import { splitKeyWithSpace } from "../../utils";

export function LoanStatusBadge({ status }: { status: LoanStatusEnum }) {
  if ([LoanStatusEnum.DISBURSED, LoanStatusEnum.APPROVED].includes(status))
    return <Badge type="success">{status}</Badge>;
  if (status === LoanStatusEnum.OVERDUE)
    return <Badge type="reject">{status}</Badge>;
  return <Badge type="pending">{splitKeyWithSpace(status)}</Badge>;
}
